<div class="login-layout">
  <div class="absolute top-4 right-4 z-20">
    <ui-theme-toggle />
  </div>

  <!-- Decorative SVG Background Elements -->
  <div class="bg-decorations">
    <!-- Lucide decorations - scattered across the page -->
    <div class="decoration hero-icon hero-icon-1">
      <ng-icon name="lucideBanknote" size="48" />
    </div>
    <div class="decoration hero-icon hero-icon-2">
      <ng-icon name="lucideChartColumn" size="44" />
    </div>
    <div class="decoration hero-icon hero-icon-3">
      <ng-icon name="lucideCreditCard" size="42" />
    </div>
    <div class="decoration hero-icon hero-icon-4">
      <ng-icon name="lucideWallet" size="40" />
    </div>
    <div class="decoration hero-icon hero-icon-5">
      <ng-icon name="lucideCalculator" size="38" />
    </div>
    <div class="decoration hero-icon hero-icon-6">
      <ng-icon name="lucideChartPie" size="46" />
    </div>
    <div class="decoration hero-icon hero-icon-7">
      <ng-icon name="lucideLandmark" size="50" />
    </div>
    <div class="decoration hero-icon hero-icon-8">
      <ng-icon name="lucideTrendingUp" size="44" />
    </div>
    <div class="decoration hero-icon hero-icon-9">
      <ng-icon name="lucideDollarSign" size="48" />
    </div>
    <div class="decoration hero-icon hero-icon-10">
      <ng-icon name="lucideReceipt" size="42" />
    </div>

    <!-- Currency symbols -->
    <svg class="decoration decoration-1" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text x="10" y="60" font-size="48" font-weight="700" fill="currentColor">$</text>
    </svg>
    <svg class="decoration decoration-2" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text x="15" y="65" font-size="42" font-weight="600" fill="currentColor">%</text>
    </svg>
    <svg class="decoration decoration-4" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text x="10" y="60" font-size="48" font-weight="700" fill="currentColor">€</text>
    </svg>
    <svg class="decoration decoration-5" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text x="15" y="55" font-size="38" font-weight="600" fill="currentColor">£</text>
    </svg>
    <svg class="decoration decoration-yen" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text x="15" y="60" font-size="44" font-weight="700" fill="currentColor">¥</text>
    </svg>
    <svg class="decoration decoration-btc" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text x="15" y="60" font-size="40" font-weight="700" fill="currentColor">₿</text>
    </svg>

    <!-- Large decorative numbers -->
    <svg class="decoration decoration-big-num-1" viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text x="5" y="60" font-size="56" font-weight="800" fill="currentColor">42</text>
    </svg>
    <svg class="decoration decoration-big-num-2" viewBox="0 0 150 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text x="5" y="60" font-size="52" font-weight="800" fill="currentColor">108</text>
    </svg>
    <svg class="decoration decoration-big-num-3" viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text x="5" y="50" font-size="44" font-weight="700" fill="currentColor">7</text>
    </svg>

    <!-- Percentage values -->
    <svg class="decoration decoration-num-1" viewBox="0 0 150 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text x="5" y="35" font-size="28" font-weight="700" fill="currentColor">+24.5%</text>
    </svg>
    <svg class="decoration decoration-num-2" viewBox="0 0 140 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text x="5" y="35" font-size="26" font-weight="600" fill="currentColor">$1,234</text>
    </svg>
    <svg class="decoration decoration-num-3" viewBox="0 0 120 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text x="5" y="35" font-size="24" font-weight="700" fill="currentColor">99.9%</text>
    </svg>
    <svg class="decoration decoration-num-4" viewBox="0 0 160 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text x="5" y="35" font-size="22" font-weight="600" fill="currentColor">-12.8%</text>
    </svg>
    <svg class="decoration decoration-num-5" viewBox="0 0 180 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <text x="5" y="35" font-size="24" font-weight="700" fill="currentColor">€9,876</text>
    </svg>

    <!-- Mini bar charts -->
    <svg class="decoration decoration-chart-1" viewBox="0 0 80 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="35" width="12" height="25" rx="2" fill="currentColor"/>
      <rect x="22" y="20" width="12" height="40" rx="2" fill="currentColor"/>
      <rect x="39" y="28" width="12" height="32" rx="2" fill="currentColor"/>
      <rect x="56" y="10" width="12" height="50" rx="2" fill="currentColor"/>
    </svg>
    <svg class="decoration decoration-chart-2" viewBox="0 0 80 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="25" width="12" height="35" rx="2" fill="currentColor"/>
      <rect x="22" y="40" width="12" height="20" rx="2" fill="currentColor"/>
      <rect x="39" y="15" width="12" height="45" rx="2" fill="currentColor"/>
      <rect x="56" y="30" width="12" height="30" rx="2" fill="currentColor"/>
    </svg>
    <svg class="decoration decoration-chart-3" viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="40" width="10" height="20" rx="2" fill="currentColor"/>
      <rect x="20" y="30" width="10" height="30" rx="2" fill="currentColor"/>
      <rect x="35" y="20" width="10" height="40" rx="2" fill="currentColor"/>
      <rect x="50" y="25" width="10" height="35" rx="2" fill="currentColor"/>
      <rect x="65" y="15" width="10" height="45" rx="2" fill="currentColor"/>
      <rect x="80" y="8" width="10" height="52" rx="2" fill="currentColor"/>
    </svg>

    <!-- Line charts -->
    <svg class="decoration decoration-line" viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <polyline points="5,45 25,30 45,38 65,18 95,25" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
      <circle cx="5" cy="45" r="4" fill="currentColor"/>
      <circle cx="25" cy="30" r="4" fill="currentColor"/>
      <circle cx="45" cy="38" r="4" fill="currentColor"/>
      <circle cx="65" cy="18" r="4" fill="currentColor"/>
      <circle cx="95" cy="25" r="4" fill="currentColor"/>
    </svg>
    <svg class="decoration decoration-line-2" viewBox="0 0 120 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <polyline points="5,50 20,35 40,42 55,20 75,28 90,12 115,18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
      <polygon points="5,60 5,50 20,35 40,42 55,20 75,28 90,12 115,18 115,60" fill="currentColor" opacity="0.2"/>
    </svg>

    <!-- Pie chart variations -->
    <svg class="decoration decoration-pie" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="40" cy="40" r="35" stroke="currentColor" stroke-width="3" fill="none" opacity="0.3"/>
      <path d="M40 5 A35 35 0 0 1 75 40 L40 40 Z" fill="currentColor"/>
    </svg>
    <svg class="decoration decoration-donut" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="40" cy="40" r="32" stroke="currentColor" stroke-width="8" fill="none" opacity="0.2"/>
      <circle cx="40" cy="40" r="32" stroke="currentColor" stroke-width="8" fill="none" stroke-dasharray="100 101" stroke-linecap="round"/>
    </svg>

    <!-- Business person silhouettes -->
    <svg class="decoration decoration-person-1" viewBox="0 0 60 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <!-- Head -->
      <circle cx="30" cy="18" r="14" fill="currentColor"/>
      <!-- Body -->
      <path d="M15 40 L15 85 C15 90 20 95 30 95 C40 95 45 90 45 85 L45 40 C45 32 38 28 30 28 C22 28 15 32 15 40Z" fill="currentColor"/>
      <!-- Tie -->
      <path d="M30 40 L26 50 L30 70 L34 50 Z" fill="currentColor" opacity="0.5"/>
    </svg>
    <svg class="decoration decoration-person-2" viewBox="0 0 70 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <!-- Head -->
      <circle cx="35" cy="16" r="12" fill="currentColor"/>
      <!-- Body with arms raised (presenting) -->
      <path d="M20 38 L20 80 C20 88 26 92 35 92 C44 92 50 88 50 80 L50 38 C50 30 44 26 35 26 C26 26 20 30 20 38Z" fill="currentColor"/>
      <!-- Arms -->
      <path d="M20 45 L5 35 L5 42 L18 50 Z" fill="currentColor"/>
      <path d="M50 45 L65 35 L65 42 L52 50 Z" fill="currentColor"/>
    </svg>

    <!-- Calculator display -->
    <svg class="decoration decoration-calc" viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="5" width="70" height="90" rx="8" stroke="currentColor" stroke-width="3" fill="none"/>
      <rect x="12" y="12" width="56" height="22" rx="3" fill="currentColor" opacity="0.3"/>
      <text x="18" y="28" font-size="14" font-weight="600" fill="currentColor">12,456</text>
      <rect x="12" y="42" width="12" height="12" rx="2" fill="currentColor" opacity="0.4"/>
      <rect x="28" y="42" width="12" height="12" rx="2" fill="currentColor" opacity="0.4"/>
      <rect x="44" y="42" width="12" height="12" rx="2" fill="currentColor" opacity="0.4"/>
      <rect x="60" y="42" width="12" height="12" rx="2" fill="currentColor" opacity="0.6"/>
      <rect x="12" y="58" width="12" height="12" rx="2" fill="currentColor" opacity="0.4"/>
      <rect x="28" y="58" width="12" height="12" rx="2" fill="currentColor" opacity="0.4"/>
      <rect x="44" y="58" width="12" height="12" rx="2" fill="currentColor" opacity="0.4"/>
      <rect x="60" y="58" width="12" height="12" rx="2" fill="currentColor" opacity="0.6"/>
      <rect x="12" y="74" width="12" height="12" rx="2" fill="currentColor" opacity="0.4"/>
      <rect x="28" y="74" width="12" height="12" rx="2" fill="currentColor" opacity="0.4"/>
      <rect x="44" y="74" width="12" height="12" rx="2" fill="currentColor" opacity="0.4"/>
      <rect x="60" y="74" width="12" height="12" rx="2" fill="currentColor" opacity="0.8"/>
    </svg>

    <!-- Trend arrows -->
    <svg class="decoration decoration-arrow-up" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M25 5 L40 25 L32 25 L32 45 L18 45 L18 25 L10 25 Z" fill="currentColor"/>
    </svg>
    <svg class="decoration decoration-arrow-down" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M25 45 L40 25 L32 25 L32 5 L18 5 L18 25 L10 25 Z" fill="currentColor"/>
    </svg>

    <!-- Coins -->
    <svg class="decoration decoration-coin-1" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="30" cy="30" r="25" stroke="currentColor" stroke-width="3" fill="none"/>
      <text x="20" y="38" font-size="24" font-weight="700" fill="currentColor">$</text>
    </svg>
    <svg class="decoration decoration-coin-2" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="30" cy="30" r="25" stroke="currentColor" stroke-width="3" fill="none"/>
      <text x="18" y="38" font-size="24" font-weight="700" fill="currentColor">€</text>
    </svg>
    <svg class="decoration decoration-coin-stack" viewBox="0 0 60 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="30" cy="68" rx="25" ry="8" fill="currentColor" opacity="0.3"/>
      <ellipse cx="30" cy="58" rx="25" ry="8" fill="currentColor" opacity="0.4"/>
      <ellipse cx="30" cy="48" rx="25" ry="8" fill="currentColor" opacity="0.5"/>
      <ellipse cx="30" cy="38" rx="25" ry="8" fill="currentColor" opacity="0.6"/>
      <ellipse cx="30" cy="28" rx="25" ry="8" fill="currentColor" opacity="0.7"/>
      <ellipse cx="30" cy="18" rx="25" ry="8" fill="currentColor"/>
    </svg>

    <!-- Document/receipt -->
    <svg class="decoration decoration-receipt" viewBox="0 0 60 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 10 L5 80 L10 75 L15 80 L20 75 L25 80 L30 75 L35 80 L40 75 L45 80 L50 75 L55 80 L55 10 C55 5 50 2 30 2 C10 2 5 5 5 10Z" stroke="currentColor" stroke-width="2" fill="none"/>
      <line x1="12" y1="20" x2="48" y2="20" stroke="currentColor" stroke-width="2"/>
      <line x1="12" y1="32" x2="42" y2="32" stroke="currentColor" stroke-width="1.5" opacity="0.5"/>
      <line x1="12" y1="42" x2="38" y2="42" stroke="currentColor" stroke-width="1.5" opacity="0.5"/>
      <line x1="12" y1="52" x2="44" y2="52" stroke="currentColor" stroke-width="1.5" opacity="0.5"/>
      <line x1="12" y1="64" x2="48" y2="64" stroke="currentColor" stroke-width="2"/>
    </svg>

    <!-- Grid pattern -->
    <svg class="decoration decoration-grid" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="0" y1="25" x2="100" y2="25" stroke="currentColor" stroke-width="1"/>
      <line x1="0" y1="50" x2="100" y2="50" stroke="currentColor" stroke-width="1"/>
      <line x1="0" y1="75" x2="100" y2="75" stroke="currentColor" stroke-width="1"/>
      <line x1="25" y1="0" x2="25" y2="100" stroke="currentColor" stroke-width="1"/>
      <line x1="50" y1="0" x2="50" y2="100" stroke="currentColor" stroke-width="1"/>
      <line x1="75" y1="0" x2="75" y2="100" stroke="currentColor" stroke-width="1"/>
    </svg>

    <!-- Dotted pattern -->
    <svg class="decoration decoration-dots" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="3" fill="currentColor"/>
      <circle cx="30" cy="10" r="3" fill="currentColor"/>
      <circle cx="50" cy="10" r="3" fill="currentColor"/>
      <circle cx="70" cy="10" r="3" fill="currentColor"/>
      <circle cx="10" cy="30" r="3" fill="currentColor"/>
      <circle cx="30" cy="30" r="3" fill="currentColor"/>
      <circle cx="50" cy="30" r="3" fill="currentColor"/>
      <circle cx="70" cy="30" r="3" fill="currentColor"/>
      <circle cx="10" cy="50" r="3" fill="currentColor"/>
      <circle cx="30" cy="50" r="3" fill="currentColor"/>
      <circle cx="50" cy="50" r="3" fill="currentColor"/>
      <circle cx="70" cy="50" r="3" fill="currentColor"/>
      <circle cx="10" cy="70" r="3" fill="currentColor"/>
      <circle cx="30" cy="70" r="3" fill="currentColor"/>
      <circle cx="50" cy="70" r="3" fill="currentColor"/>
      <circle cx="70" cy="70" r="3" fill="currentColor"/>
    </svg>

    <!-- Hexagon pattern -->
    <svg class="decoration decoration-hex" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <polygon points="50,5 90,27 90,73 50,95 10,73 10,27" stroke="currentColor" stroke-width="2" fill="none"/>
      <polygon points="50,25 70,37 70,63 50,75 30,63 30,37" stroke="currentColor" stroke-width="1.5" fill="none" opacity="0.5"/>
    </svg>
  </div>

  <router-outlet />
</div>
